// Backend aliases are equivalent permissions, not additional privileges. Keep the
// authoritative role for diagnostics while using the established UI vocabulary.
const UI_ROLE = {agency_admin:'admin',manager:'ops_manager',processor:'bpo',auditor:'future'};
export function normalizeSessionUser(user) {
  if (!user || typeof user !== 'object') return user;
  const serverRole=user.server_role || user.role;
  return {...user,server_role:serverRole,role:UI_ROLE[serverRole] || serverRole};
}
